import React, { useEffect, useState } from 'react';
import { API_BASE } from '../utils/apiBase';

export default function DashboardHoneyPot({ token }) {
  const [events, setEvents] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');

  const fetchEvents = async () => {
    setLoading(true);
    setError('');
    try {
      const response = await fetch(`${API_BASE}/api/security/honeypot/events?limit=100`, {
        headers: {
          Authorization: `Bearer ${token}`
        }
      });

      if (!response.ok) {
        throw new Error('Falha ao carregar eventos HoneyPot');
      }

      const data = await response.json();
      setEvents(Array.isArray(data.events) ? data.events : []);
    } catch (err) {
      setError('Não foi possível carregar os eventos do HoneyPot.');
      setEvents([]);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchEvents();
  }, [token]);

  return (
    <div style={{ display: 'grid', gap: 12 }}>
      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
        <h3 style={{ margin: 0 }}>HoneyPot - Tentativas de Inspeção</h3>
        <button onClick={fetchEvents}>Atualizar</button>
      </div>

      {loading && <p>Carregando eventos...</p>}
      {error && <p style={{ color: '#b91c1c' }}>{error}</p>}

      {!loading && !error && events.length === 0 && (
        <p>Nenhum evento detectado até o momento.</p>
      )}

      {!loading && !error && events.length > 0 && (
        <div style={{ overflowX: 'auto' }}>
          <table style={{ width: '100%', borderCollapse: 'collapse', fontSize: 13 }}>
            <thead>
              <tr>
                <th style={{ textAlign: 'left', borderBottom: '1px solid #ddd', padding: 8 }}>Data/Hora</th>
                <th style={{ textAlign: 'left', borderBottom: '1px solid #ddd', padding: 8 }}>IP</th>
                <th style={{ textAlign: 'left', borderBottom: '1px solid #ddd', padding: 8 }}>Localização</th>
                <th style={{ textAlign: 'left', borderBottom: '1px solid #ddd', padding: 8 }}>Motivo</th>
                <th style={{ textAlign: 'left', borderBottom: '1px solid #ddd', padding: 8 }}>Página</th>
              </tr>
            </thead>
            <tbody>
              {events.map((event, index) => {
                const location = event.location?.resolved
                  ? `${event.location.city || '-'}, ${event.location.region || '-'} - ${event.location.country || '-'}`
                  : 'Não resolvida';

                return (
                  <tr key={`${event.timestamp || 't'}-${event.ip || 'ip'}-${index}`}>
                    <td style={{ borderBottom: '1px solid #eee', padding: 8 }}>
                      {event.timestamp ? new Date(event.timestamp).toLocaleString('pt-BR') : '-'}
                    </td>
                    <td style={{ borderBottom: '1px solid #eee', padding: 8 }}>{event.ip || '-'}</td>
                    <td style={{ borderBottom: '1px solid #eee', padding: 8 }}>{location}</td>
                    <td style={{ borderBottom: '1px solid #eee', padding: 8 }}>{event.reason || '-'}</td>
                    <td style={{ borderBottom: '1px solid #eee', padding: 8 }}>{event.path || '-'}</td>
                  </tr>
                );
              })}
            </tbody>
          </table>
        </div>
      )}
    </div>
  );
}
